import type { IconData } from '@stacksjs/iconify-core'

export const moneyWallet: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 4H16v12H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h10v2.5H2.5zM13 11.25a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default moneyWallet
